import MilitaryState from './MilitaryState';

export default MilitaryState;
